import { useEffect, useState } from 'react';

/**
 * @param value to debounce
 * @param delay in ms
 * @returns debounced value
 * @example
 * const debouncedValue = useDebounce(value, 500);
 */
export default function useDebounce<T>(value: T, delay: number): T {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
